module.exports = __webpack_public_path__ + "static/img/day-banner.eb7415b4.png";